import { readActivityProgress } from "./teacherWorkApi";
import { recordFailure } from "./syncDiagnostics";
import usePolledResource, { TEACHING_MS } from "./usePolledResource";

// Class progress for one released activity, refreshed while teaching.
const useClassProgress = (query, enabled = true) => {
  const { classroomId, deliverySyncKey, activityId } = query;
  const progress = usePolledResource(
    () =>
      readActivityProgress({ classroomId, deliverySyncKey, activityId }).catch((error) => {
        // The gateway's reason (status and refusal) goes to window.__deliverySync().
        recordFailure(`class-progress:${activityId}`, error);
        throw error;
      }),
    `${classroomId}:${deliverySyncKey}:${activityId}`,
    { intervalMs: TEACHING_MS, enabled }
  );
  return { ...progress, refresh: progress.retry };
};

export default useClassProgress;
